/* eslint-disable jira/filename-case */
export const FETCH_ERROR_FLAG_ID = 'fetchError';
export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4SidebarsContentOperations';
export const TEAM_NAME = 'alexstrasza';
